import React from "react";
import { DraftPost } from "../types";

interface GeneratedPostsProps {
  posts: DraftPost[];
  onSave: (selectedPosts: DraftPost[]) => void;
  isSaving?: boolean;
  /** Opens the right-panel canvas for a specific post. */
  onOpenCanvas?: (post: DraftPost) => void;
  onInsertImage?: (tempId: string) => void | Promise<void>;
}

export const GeneratedPosts: React.FC<GeneratedPostsProps> = ({
  posts,
  onOpenCanvas,
}) => {
  if (posts.length === 0) return null;

  return (
    <div className="my-3">
      {/* Single CTA — open all drafts in the canvas panel */}
      <button
        type="button"
        onClick={() => onOpenCanvas && onOpenCanvas(posts[0])}
        disabled={!onOpenCanvas}
        className="group flex w-full items-center justify-between rounded-2xl border border-theme-border bg-gradient-to-r from-theme-surface-ui via-theme-surface to-transparent px-4 py-3 text-left transition-all hover:border-theme-primary/35 hover:from-theme-secondary/20 active:scale-[0.99] disabled:cursor-default disabled:opacity-60"
      >
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-theme-secondary/20 transition-colors group-hover:bg-theme-secondary/30">
            <span className="material-icons text-[20px] text-theme-primary">space_dashboard</span>
          </span>
          <div>
            <p className="text-[13px] font-bold text-theme-fg">
              {posts.length} {posts.length === 1 ? "Post" : "Posts"} Ready in Canvas
            </p>
            <p className="text-[11px] text-theme-fg-muted">
              Preview &amp; edit each platform's post on the right →
            </p>
          </div>
        </div>
        <span className="flex flex-shrink-0 items-center gap-1.5 rounded-xl bg-theme-primary px-3 py-1.5 text-[11px] font-bold text-white shadow-sm transition-all group-hover:opacity-90 group-hover:shadow-theme-primary/25 group-hover:shadow-md">
          <span className="material-icons text-[14px]">open_in_new</span>
          Open Canvas
        </span>
      </button>
    </div>
  );
};
